import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate, useRoutes } from 'react-router-dom'
import { logoutUser } from '../store/actions'
import LoginPage from '../views/auth/LoginPage'
import RegisterPage from '../views/auth/RegisterPage'
import MinimalLayout from '../layout/MinimalLayout'

export default function AuthenticationRoutes() {
  const dispatch: any = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const token = Cookies.get('dot-ad-token')

    if (!token && location.pathname !== '/login' && location.pathname !== '/register') {
      navigate('/')
      dispatch(logoutUser())
    }

    if (token && (location.pathname === '/login' || location.pathname === '/register')) {
      navigate('/')
    }
  }, [location.pathname, dispatch, navigate])

  const list = [
    {
      path: '/',
      element: <MinimalLayout />,
      children: [{ path: '*', element: <MinimalLayout /> }]
    },
    { path: '/login', element: <LoginPage /> },
    { path: '/register', element: <RegisterPage /> }
  ]
  return useRoutes(list)
}
